import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.inquiryDraft.submitInquiry;
export const submitInquiryIsLoadingSelector = (state: RootState) => getState(state).isLoading;
